<template>
  <section class="widget widget-goals" :class="[{ [`widget-${type}`]: type }]">
    <h3 class="widget-title">
      {{
        `¿Qué logró su publicidad digital ${
          $route.params.productName
            ? `en ${change($route.params.productName)}`
            : ""
        }?`
      }}
    </h3>
    <div class="cards-wrapper">
      <card type="goals" v-if="totalImpressions">
        <div class="card-header">
          <div class="icon-wrapper">
            <font-awesome-icon icon="eye" />
          </div>
          <h4 class="card-title">Impresiones</h4>
        </div>
        <div class="card-content">
          <h1>{{ numberLetter(totalImpressions) }}</h1>
          <p>{{ wording.Impressions }}</p>
        </div>
      </card>

      <card type="goals" v-if="totalClicks">
        <div class="card-header">
          <div class="icon-wrapper">
            <font-awesome-icon icon="mouse-pointer" />
          </div>
          <h4 class="card-title">Clicks</h4>
        </div>
        <div class="card-content">
          <h1>{{ numberLetter(totalClicks) }}</h1>
          <p>{{ wording.Clicks }}</p>
        </div>
      </card>

      <card type="goals" v-if="totalCtrPercentage">
        <div class="card-header">
          <div class="icon-wrapper">
            <font-awesome-icon icon="percent" />
          </div>
          <h4 class="card-title">CTR</h4>
        </div>
        <div class="card-content">
          <h1>{{ totalCtrPercentage }}%</h1>

          <p>{{ wording.CTR }}</p>
        </div>
      </card>

      <card type="goals" v-if="totalReach">
        <div class="card-header">
          <div class="icon-wrapper">
            <font-awesome-icon icon="bullseye" />
          </div>
          <h4 class="card-title">Alcance</h4>
        </div>
        <div class="card-content">
          <h1>{{ numberLetter(totalReach) }}</h1>
          <p>{{ wording.Reach }}</p>
        </div>
      </card>
    </div>

    <h3 class="widget-title">
      {{
        `Interacciones ${
          $route.params.productName
            ? `en ${change($route.params.productName)}`
            : ""
        }`
      }}
    </h3>
    <div class="cards-wrapper">
      <card type="goals" v-if="totalComments">
        <div class="card-header">
          <div class="icon-wrapper">
            <font-awesome-icon icon="comments" />
          </div>
          <h4 class="card-title">Comentarios</h4>
        </div>
        <div class="card-content">
          <h1>{{ numberLetter(totalComments) }}</h1>
          <p>{{ wording.Comments }}</p>
        </div>
      </card>

      <card type="goals" v-if="totalLikes">
        <div class="card-header">
          <div class="icon-wrapper">
            <font-awesome-icon icon="thumbs-up" />
          </div>
          <h4 class="card-title">Likes</h4>
        </div>
        <div class="card-content">
          <h1>{{ numberLetter(totalLikes) }}</h1>
          <p>{{ wording.Likes }}</p>
        </div>
      </card>

      <card type="goals" v-if="totalShares">
        <div class="card-header">
          <div class="icon-wrapper">
            <font-awesome-icon icon="share" />
          </div>
          <h4 class="card-title">Compartidos</h4>
        </div>
        <div class="card-content">
          <h1>{{ numberLetter(totalShares) }}</h1>
          <p>{{ wording.Shares }}</p>
        </div>
      </card>

      <card type="goals" v-if="totalVideoViews">
        <div class="card-header">
          <div class="icon-wrapper">
            <font-awesome-icon icon="video" />
          </div>
          <h4 class="card-title">Reproducciones Completas</h4>
        </div>
        <div class="card-content">
          <h1>{{ numberLetter(totalVideoViews) }}</h1>
          <p>{{ wording.VideoViews }}</p>
        </div>
      </card>
    </div>
  </section>
</template>
<script>
export default {
  name: "ads-tiktok-goals",
  props: {
    type: String,
    wording: Object,
    totalImpressions: {
      type: Number,
      default: 0
    },
    totalClicks: {
      type: Number,
      default: 0
    },
    totalCtrPercentage: {
      type: String,
      default: 0
    },
    totalReach: {
      type: Number,
      default: 0
    },
    totalComments: {
      type: Number,
      default: 0
    },
    totalLikes: {
      type: Number,
      default: 0
    },
    totalShares: {
      type: Number,
      default: 0
    },
    totalVideoViews: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  methods: {
    change(ProductName) {
      if (ProductName === "AnunciosdebúsquedaenGoogle") {
        return "Anuncios de búsqueda en Google";
      } else if (ProductName === "Paginasamarillas.com.do") {
        return "Paginasamarillas.com.do";
      } else if (ProductName === "AnunciosdeMáximoRendimiento") {
        return "Anuncios Máximo Rendimiento de Google";
      } else if (ProductName === "SocialMediaPost") {
        return "Social Media Post";
      } else if (ProductName === "AnunciosdeYoutube") {
        return "Anuncios de Youtube";
      } else if (ProductName === "AnunciosdeRedesSociales") {
        return "Anuncios de Redes Sociales";
      } else if (ProductName === "AnunciosdeDisplayenGoogle") {
        return "Anuncios de Display en Google";
      } else if (ProductName === "CampañasLocales") {
        return "Anuncios de Campañas Locales";
      } else if (ProductName === "SuWebsite") {
        return "Su Website";
      } else if (ProductName === "GoogleMyBusiness") {
        return "Google My Business";
      } else if (ProductName === "SpotifyAds") {
        return "Spotify Ads";
      } else if (ProductName === "LinkedInAds") {
        return "Linkedin Ads";
      } else if (ProductName === "GoogleCampaigns") {
        return "Google Campaigns";
      } else {
        return ProductName;
      }
    },
    numberLetter(value) {
      let suffixes = [
        "U",
        "D",
        "C",
        "K",
        "K",
        "K",
        "M",
        "M",
        "M",
        "B",
        "B",
        "B",
        "T",
        "T",
        "T"
      ];

      let stringValue = value ? value.toString() : "0";
      let valueLength = stringValue.length;
      let suffix = suffixes[valueLength - 1];

      const BASEDIVISOR = 3;
      let startindex = 0;
      let characterToTake = valueLength % BASEDIVISOR;
      characterToTake = characterToTake == 0 ? BASEDIVISOR : characterToTake;

      if (valueLength > BASEDIVISOR) {
        let wholePart = stringValue.substr(startindex, characterToTake);
        let decimalPart = stringValue.substr(
          startindex + characterToTake,
          BASEDIVISOR
        );

        let firstDecimal = decimalPart.substr(startindex, 1);

        let wholeNumber =
          firstDecimal != "0"
            ? wholePart + "." + decimalPart.substr(startindex, 1) + suffix
            : wholePart + suffix;

        return wholeNumber;
      }

      return stringValue;
    }
  }
};
</script>
<style lang="scss" scoped>
.widget {
  &.widget-goals {
    .card-goals {
      .card-content {
        text-align: center;
        h1 {
          span {
            font-size: 24px;
          }
          font-size: 35px;
          font-weight: $font-medium;

          color: $highlight-color;
        }
      }
    }
  }
  &.brand-impact {
    .card-line-chart {
      .card-top {
        .card-number {
          text-align: center;
          h3 {
            color: $highlight-color;
          }
        }
      }
    }
  }
}
@include respond-above(sm) {
  .widget {
    &.widget-goals {
      .cards-wrapper {
        display: grid;
        grid-template-columns: repeat(4, minmax(100px, 1fr));
        grid-gap: 20px;
      }
    }
  }
}
</style>
